var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPushPin = function SvgIconPushPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.324 1.696a1.75 1.75 0 0 1 1.92.383l.003.004 5.67 5.67.004.003a1.75 1.75 0 0 1 0 2.488l-.003.003-5.365 5.364c.814 2.46-.587 4.733-1.327 5.711a1.75 1.75 0 0 1-2.642.177L8.25 17.164l-3.043 3.043a1 1 0 1 1-1.414-1.414l3.043-3.043-4.352-4.352-.002-.002a1.75 1.75 0 0 1 .133-2.601c1.604-1.297 3.198-1.593 4.408-1.54.542.025 1 .118 1.343.215l5.39-5.39a1.8 1.8 0 0 1 .568-.384M8.178 9.52l.002.002h.003l.002.002-.005-.002-.05-.022a3 3 0 0 0-.244-.085 4 4 0 0 0-.952-.16c-.734-.033-1.745.12-2.84.925l4.863 4.864 4.842 4.841c.717-1.027 1.418-2.595.683-4.06a1 1 0 0 1 .186-1.156L20.336 9 15 3.664 9.332 9.332a1 1 0 0 1-1.147.191m-.007-.004",
    clipRule: "evenodd"
  })));
};
export default SvgIconPushPin;